
import { motion } from 'framer-motion'
import background from '../../assets/images/background.jpg'
import guipic from '../../assets/images/gui-pic.png'
import scale from '../../assets/images/scale.png'
import ai from '../../assets/images/shutterstock_2473384115.jpg'
import ai2 from '../../assets/images/shutterstock_2501574955.jpg'
import {Link} from 'react-router-dom'
const sections = [
  {
    title: "LLM Application Platform",
    subtitle: "Generative AI training platform, low threshold to enter Gen AI on-premise training, establish private LLM model",
    description: {
        mainText: "LLMOps",
        points: [
          "Data Preprocessing",
          "Language Model Training",
          "Monitoring",
          "Fine-tuning",
          "Deployment"
        ]
      },
    image: guipic,
    buttonText: "Inquire",
    buttonSubtext: "(It's free and always will be)",
    imageLeft: true
  },
  {
    title: "Dataset Auto-Generator",
    subtitle: "Preparing Dataset is the first step in training model. General files cannot be directly imported into training and need to be converted into a specific format first.",
    description: {
        mainText: "Supported Formats:",
        points: [
          "PDF,CSV,XLSX,DOCX,TXT",
          "Maximum document size: 120K tokens",
          "90% time saving in preparing training dataset",
          
        ]
      },
    image: scale,
    buttonText: "Inquire",
    buttonSubtext: "(Premium content available)",
    imageLeft: false
  },
  {
    title: "AI Main Assistant",
    subtitle: "Connect with GenAI functions through email to create customized AI mail assistant",
    description: 
        {
        mainText: "Basic",
        points: [
          "Summary,multiple language translation",
          "Action item,reply email",
          "External web search",
          "Attachment analysis (word,ppt,pdf...)",
          "Knowledge management system",
          "AI Meeting Assistant"
          
        ]
        
      },
    image: ai,
    buttonText: "Inquire",
    buttonSubtext: "(Premium content available)",
    imageLeft: true
  },
  {
    title: "AI Enabled Border Monitoring & Surveillance Solution",
    subtitle: "Reach Your Audience Worldwide",
    description: {
        mainText: "Our Applications:",
        points: [
          "MiPhi Enables AI Deployment at Border Entry Gates and Across All Toll Gates Across the Geography, Ranging from District to State to Nationwide, With Cost & Performance Efficiency",
          "Deployment is Both at Edge Point and also Central Monitoring Station Regionwise, Inturn Connected Nationwide for Information Sharing and Tracking",
          "Helps in Various Applications like AI Enabled Drug & Narcotic, Human Trafficking, Criminal Activity Surveillance to give Enhanced Intelligence & Timely Response for Crime Prevention and Control",
          
        ]
      },
    image:ai2,
    buttonText: "Inquire",
    buttonSubtext: "(It's free and always will be)",
    imageLeft: false
  }
]

const fadeIn = {
  hidden: { opacity: 0, y: 20 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: {
      duration: 0.6
    }
  }
}

const slideIn = {
  hidden: { opacity: 0, x: -60 },
  visible: { 
    opacity: 1, 
    x: 0,
    transition: {
      duration: 0.8
    }
  }
}

const Section = ({ title, subtitle, description, image, buttonText, buttonSubtext, imageLeft, index }) => {
  return (
    <div className="min-h-screen flex items-center justify-center p-4 md:p-8">
       
      <motion.div 
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        className={`max-w-7xl mx-auto grid md:grid-cols-2 gap-8 items-center ${imageLeft ? 'md:grid-flow-row' : 'md:grid-flow-row-dense'}`}
      >
        {/* Image Section */}
        <motion.div 
          variants={slideIn}
          className={`relative ${imageLeft ? 'md:order-1' : 'md:order-2'}`}
        >
          <div className="relative group">
            <div className="absolute -inset-1 rounded-lg blur opacity-25 group-hover:opacity-40 transition duration-1000"></div>
            <div className="relative  overflow-hidden rounded-lg">
              <img 
                src={image}
                alt={title}
                className="w-full h-full object-cover transform  transition duration-700"
              />
              <div className="absolute inset-0  mix-blend-overlay"></div>
            </div>
          </div>
        </motion.div>

        {/* Content Section */}
        <motion.div 
          variants={fadeIn}
          className={`space-y-6 ${imageLeft ? 'md:order-2' : 'md:order-1'}`}
        >
          <div className="relative p-8 rounded-2xl overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-br from-black-900/10 to-black/10 backdrop-blur-xl"></div>
            <div className="relative z-10">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                {title}
              </h2>
              <h3 className="text-xl text-emerald-200 mb-4">
                {subtitle}
              </h3>
              <div className="text-gray-300 mb-8">
                  <p className="mb-4">{description.mainText}</p>
                  <ul className="space-y-2 list-disc list-inside">
                    {description.points.map((point, i) => (
                      <motion.li 
                        key={i}
                        initial={{ opacity: 0, x: -20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ delay: i * 0.1 }}
                        className="text-gray-300"
                      >
                        {point}
                      </motion.li>
                    ))}
                  </ul>
                </div>
              <div className="space-y-4">
                <Link to="/contact"><button className="w-full md:w-auto px-8 py-3 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg transition-all duration-300 transform hover:scale-105">
                  {buttonText}
                </button></Link>
                <p className="text-sm text-gray-400 ">
                  {buttonSubtext}
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </motion.div>
    </div>
  )
}


const AlternatingSections = () => {
  return (
    <div className="bg-black min-h-screen">
      {/* Hero Section */}
      <motion.section 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
          className="relative  h-screen lg:h-screen 2xl:h-[60vh]  flex items-center justify-center"
        >
          <div 
            className="absolute inset-0 z-0 bg-gradient-to-b from-black/40 to-black"
            style={{
              backgroundImage: `url(${background})`, 
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              filter: 'brightness(0.3)'
            }}
          />
          <div className="relative z-10 max-w-4xl mx-auto px-4 text-center">
            <motion.h1 
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.5 }}
              className="text-5xl md:text-7xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-emerald-600"
            >
              Solutions
            </motion.h1>
            <motion.p
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.5 }}
              className="text-lg md:text-xl text-gray-300"
            >
              Empowering businesses with cutting-edge tools and systems to enhance efficiency, drive innovation, and achieve digital transformation.
            </motion.p>
          </div>
        </motion.section>
      {sections.map((section, index) => (
        <Section key={index} {...section} index={index} />
      ))}
    </div>
  )
}

export default AlternatingSections

